.toastContainer {
  font-family: $font_family;
  transition: height 0.25s ease-in, margin-top 0.25s ease-in-out;
  overflow: hidden;
  height: 0;
  margin-top: 0;
  display: flex;
  width: 410px;
  max-width: calc(100% - 30px);
  justify-content: center;
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 10001;

  &.stopAnimation {
    height: 0 !important;
    margin-top: 0 !important;
  }

  .toast {
    display: flex;
    width: 100%;
    height: fit-content;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 24px;
    background-color: #142F43;
    color: #ffffff;
    border-radius: 12px;
    font-weight: 500;
    text-align: start;

    a {
      color: #F0F2F5;
    }
    @include dark-mode {
      background-color: #2D3941;
      color: #F0F2F5;
      a {
        color: #142F43;
      }
    }

    &.startAnimation {
      animation: fadein .25s ease-in-out forwards;
    }

    &.stopAnimation {
      animation: fadeout .25s ease-in-out forwards;
    }
    
    &.error {
      @include themify($themes) {
        background-color: themed("error-primary");
        color: #ffffff;
      }
    }
    
    .onAbort {
      @include themify($themes) {
        color: themed("brand-primary");
      }
      text-decoration: underline;
      text-transform: capitalize;
    }

    .xButton {
      display: flex;
      justify-content: end;
      border: none;
      background: transparent;
      cursor: pointer;
    }
  }
}


@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

